import {useMemo} from 'react';
import _get from 'lodash/get';
import {
  multipleSubscriptionsUtils,
  solutionUtils,
} from '../../utils/solutionUtils';

const useSolutionType = auth => {
  const subscriptionItems = _get(auth, 'subscriptionItems', []);
  const overdueSolutions = multipleSubscriptionsUtils.overdueSolutions(auth);
  const solutionInfos = multipleSubscriptionsUtils.getSolutionInfos(auth);
  return useMemo(() => {
    const areMultipleSolutions = solutionUtils.isMultipleSolutions(auth);
    const isSkinAnalysis = multipleSubscriptionsUtils
      .getSolutionTypes(auth)
      .includes('SKIN_ANALYSIS');
    const isOverdueSkinAnalysis = overdueSolutions.includes('SKIN_ANALYSIS');
    const isSkinAnalysisPremium = _get(
      solutionInfos,
      'SKIN_ANALYSIS.isPremiumPlan',
      true
    );
    const isSkinAnalysisTrialPlan = _get(
      solutionInfos,
      'SKIN_ANALYSIS.isTrialPlan',
      true
    );
    const isSimulation = multipleSubscriptionsUtils
      .getSolutionTypes(auth)
      .includes('AESTHETIC_SIMULATION');
    const isOverdueSimulation = overdueSolutions.includes(
      'AESTHETIC_SIMULATION'
    );
    const isSimulationPremium = _get(
      solutionInfos,
      'AESTHETIC_SIMULATION.isPremiumPlan',
      true
    );
    const isSimulationTrialPlan = _get(
      solutionInfos,
      'AESTHETIC_SIMULATION.isTrialPlan',
      true
    );

    const getSkinAnalysisEnterpriseSettings = () => {
      try {
        return JSON.parse(
          _get(solutionInfos, 'SKIN_ANALYSIS.enterpriseSettings', '[]')
        );
      } catch (error) {
        return [];
      }
    };

    return {
      areMultipleSolutions,
      areOverdue: overdueSolutions.length === subscriptionItems.length,
      isSkinAnalysis,
      isOverdueSkinAnalysis,
      isSkinAnalysisPremium,
      isSkinAnalysisTrialPlan,
      isSimulation,
      isOverdueSimulation,
      isSimulationPremium,
      isSimulationTrialPlan,
      enterpriseSettings: getSkinAnalysisEnterpriseSettings(),
    };
  }, [subscriptionItems, overdueSolutions, solutionInfos]);
};

export default useSolutionType;
